import { Component,ViewChild, OnInit, AfterViewInit} from '@angular/core';

import {Jsonp, Http, Headers, URLSearchParams, Response, RequestOptions } from '@angular/http';
import {FormControl, FormGroup} from '@angular/forms';

import { Observable } from 'rxjs/Observable';
import { Subject }    from 'rxjs/Subject';
import 'rxjs/add/observable/fromPromise';

import Layer = require('esri/layers/Layer');
import PopupTemplate = require('esri/PopupTemplate');
import Graphic = require('esri/Graphic');
import Point = require('esri/geometry/Point');
import Extent = require('esri/geometry/Extent');
import PictureMarkerSymbol = require('esri/symbols/PictureMarkerSymbol');
import RouteTask = require('esri/tasks/RouteTask');
import RouteParameters = require('esri/tasks/support/RouteParameters');
import FeatureSet = require('esri/tasks/support/FeatureSet');
import SimpleMarkerSymbol = require('esri/symbols/SimpleMarkerSymbol');
import SimpleLineSymbol = require('esri/symbols/SimpleLineSymbol');
// import SpatialReference = require('esri/geometry/SpatialReference');
import Color = require('esri/Color');
import GraphicsLayer = require('esri/layers/GraphicsLayer');
import DirectionsFeatureSet  = require('esri/tasks/support/DirectionsFeatureSet')
import { EventsService } from '../../shared/Events.service';
import { MapService } from './map.service';
import { SettingsService } from '../../shared/settings/settings.service';
import PrintTask = require('esri/tasks/PrintTask');
import PrintTemplate = require('esri/tasks/support/PrintTemplate');
import PrintParameters = require('esri/tasks/support/PrintParameters');

declare var componentHandler: any;

@Component({
    selector: 'map-view',
    template: require('./mapview.component.html')
})

export class MapViewComponent implements OnInit, AfterViewInit {
    mapSlider:Element;
    mapViewRef:any;
    mapSliderControl = new FormControl();
    precinctToggleControl = new FormControl();
    
    initTransparencyValue: number = 0;
    precinctsDisplay: boolean = false;

    pollingLocation: Object;
    pollingPlaceFacility: Object;
    satelliteVotingPlaces: Array<Object> = [];
    selectedSatellite:Object;
    homeLocation: Object;
    homeGraphic: Graphic;
	pollingGraphic: Graphic;
    selectedAddress:Object;
    selectedAddressString:string = "";
    routeDirectionList:Array<any>;

    showDirections:boolean = false;
    
    tabActivated:boolean = false;
    appSettings: Object;
    error: any;

    directionsAddrToggleControl = new FormControl();
    stopSelectControl = new FormControl();

    useDiffAddress:boolean = false;
    newStartAddress:Object;
    startAddrText:string;
    stopAddrText:string;

    routeInProgress:boolean = false;

    routeExtent:Extent;
    routeResult:any; 
    directionsStartAddress:Object;
    selectedStop: string = "polling";
    exportedMapImgURL: string = "";
    showPrint:boolean  = false;
    printInProgress:boolean = false;

    panelHide:boolean = false;
         //email
     toAddress:string;
     fromAddress:string; 
     emailSubject:string;
     emailBody:string;
     message:Object;
     showEmailPanel:boolean = false;

    IEbrowser:boolean = false;
    internetExplorer:boolean = false;

    private baselayer:Layer;
    private aeriallayer:Layer;
    private precinctslayer:Layer;
    private locationGraphics:GraphicsLayer;
    private routelayer:GraphicsLayer ;

    constructor( private _eventsService: EventsService, private _mapService: MapService,  private _settingsService: SettingsService, private http: Http, private jsonp:Jsonp) { 
    
    }
    
    ngOnInit() {
        if (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1 || navigator.userAgent.indexOf("Edge/") > -1)  {
            this.IEbrowser = true;
        }
        if (navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1) {
            this.internetExplorer = true;
        } 
        // Get app settings from settings service      
        this._settingsService.getAppSettings().subscribe(
            settings => { 
                this.appSettings = settings[0];

                let currentTabSettings:Object = this.appSettings["widgets"].filter(item => { return item.name === 'Map'; });
                this.tabActivated = currentTabSettings[0].activate;
            
            },
            err => { this.error = true }
        ); 

        //listen for command to get driving directions
        this._eventsService.directionsInvoked$.subscribe(destination => {
            //clear any existing list of directions
            this.showDirections = false;
            this.routelayer ? this.routelayer.removeAll(): null;
            //Get the current address location
            destination ? this.selectedStop = destination : console.log("A destination was not provided.");
            let tabpanels: any = document.querySelectorAll('.mdl-tabs__panel');
            let tabs: any = document.querySelectorAll('.mdl-tabs__tab');
            // let view: any = tabview;
            for (let tabpanel of tabpanels) {
                tabpanel.classList.contains('is-active') ? tabpanel.classList.remove('is-active') : null;
                tabpanel.id === "directions-panel" ? tabpanel.classList.add('is-active') : null;
            }
            for (let tab of tabs) {
                tab.classList.contains('is-active') ? tab.classList.remove('is-active') : null;
                tab.hash === "#directions-panel" ? tab.classList.add('is-active') : null;
            }
        });
    }

    ngAfterViewInit() {

    }

    inputChange(event){
        if(this.internetExplorer){
            this.initTransparencyValue = event.currentTarget.value;
            this.sliderChange(event.currentTarget.value);
        }
    }
    
    startAddressIsSelected(address:Object) {
        // selectedAddressItem
        address ? this.newStartAddress = address: this.newStartAddress = null;
        this.directionsStartAddress = this.newStartAddress 
    }

    validateAddressToggle(validAddress:boolean) {
        !validAddress ? this.directionsStartAddress = null: null;
    }

     
    onMapLoad(response) {
         //handle event when the map/aerial slider value changes
        this.mapSliderControl.valueChanges
            .subscribe(n => this.sliderChange(n));
        
        //handle event when the precincts layer toggle value changes
        this.precinctToggleControl.valueChanges
            .subscribe(n => this.precinctsToggle(n));

        //handle event when the directions start address toggle value changes
        this.directionsAddrToggleControl.valueChanges
            .subscribe(n => this.directionsAddrToggle(n));
        

         //get a reference to the MapView
        this.mapViewRef = response;
        
        //get references for the respective map layers
        this.mapViewRef.map.layers.forEach((layer) => {
            if (layer.id === 'aerial') {
                this.aeriallayer = layer;
            }

            if (layer.id === 'precincts') {
                this.precinctslayer = layer;
                //  this.precinctslayer.visible = this.precinctsDisplay;
            }


            if (layer.id === 'route') {
                this.routelayer = layer as GraphicsLayer;
            };

            if(layer.id === "locations"){
                this.locationGraphics = layer as GraphicsLayer;
            }
            
        });  

        //disable map rotation
        this.mapViewRef.constraints = {
            rotationEnabled: false
        };

        //listen for any new selected addresses resulting from a new search
        this._eventsService.selectedAddressObject$.subscribe(address => {
            //this.mapViewRef.graphics.removeAll();
            this.locationGraphics.removeAll();

            //clear any routing results
            this.showDirections = false;
            this.routelayer.removeAll();

            //Get the current address location
            address ? this.selectedAddress = address: console.log("address object is not set.");
            this.selectedAddress ? this.directionsStartAddress = this.selectedAddress : null;
            // address ? this.addHomeAddressGraphic(address): console.log("address object is not set.")
        }); 

        //listen for the new polling place
        this._eventsService.pollingPlace$.subscribe(pollingplace => {
                //this.mapViewRef.graphics.removeAll();
                this.locationGraphics.removeAll();
                //Get the current address location
                pollingplace ? this.addPollingPlaceGraphic(pollingplace): console.log("polling place object is not set.")
                this.pollingPlaceFacility = pollingplace;
                this.selectedAddress ? this.addHomeAddressGraphic(this.selectedAddress): console.log("address object is not set.")
            }
        ); 

        //listen for new satellite polling places
        this._eventsService.satellites$.subscribe(satellites => {
                //Get the current address location
                satellites ? this.addSatellitesGraphic(satellites as Array<Object>): console.log("satellite voting object is not set.");
                this.satelliteVotingPlaces = satellites as Array<Object>;
            }
        ); 

        //listen for command to zoom to a location 
        this._eventsService.mapZoom$.subscribe(votingLocation => {
                //Get the current address location
                votingLocation["place"]["Location"] ? this.zoomMaptoLocation(votingLocation["place"]["Location"]): console.log("satellite voting object is not set.")
                this.selectedStop = votingLocation["id"];
            }
        ); 

        this.mapViewRef.popup.dockOptions = {
            // Disables the dock button from the popup
            buttonEnabled: false,
            // Ignore the default sizes that trigger responsive docking
            breakpoint: false,
            position: "bottom-right" 
        };
    }

    ngAfterViewChecked() {
        
    }

    //Add the home graphic for the voters address
    addHomeAddressGraphic(address) {
        //let selectedAddressLocation: Object = address["addressLocation"];
        this.homeLocation = address["addressLocation"];
        
        let homeAddress: Object = address["addressSuggestion"];
        this.selectedAddressString = homeAddress["FullAddress"] + ", IN " + homeAddress["Zip"];

        // let sr: SpatialReference = this.mapViewRef.spatialReference;
        
        var pt: Point = new Point({
            x: this.homeLocation ["X"],
            y: this.homeLocation ["Y"],
            spatialReference: 2965
        });

    
        let markerSymbol = new PictureMarkerSymbol();
             markerSymbol.url = "./images/home_red.png";
             markerSymbol.width = 48;
             markerSymbol.height = 48;

        let homeAtt = {
            Name: "Home",
            Address: this.selectedAddressString 
            
        };

        this.homeGraphic = new Graphic({
            geometry: pt,
            symbol: markerSymbol,
            attributes: homeAtt,
            popupTemplate: new PopupTemplate({
                title: "{Name}",  
                content: "{Address}"    
            })
        });

        //this.mapViewRef.graphics.add(this.homeGraphic);
        this.locationGraphics.add(this.homeGraphic);
        this.zoomMaptoLocation(this.homeLocation)
    }

    //Add a graphic for the voters polling place
    addPollingPlaceGraphic(pollingplace: Object) {
        this.pollingLocation = pollingplace["Location"];

        var pt: Point = new Point({
            x: this.pollingLocation ["X"],
            y: this.pollingLocation ["Y"],
            spatialReference: 2965
        });


        let markerSymbol = new PictureMarkerSymbol();
            markerSymbol.url = "./images/polling_green.png";
            markerSymbol.width = 48;
            markerSymbol.height = 48;

        let pollingAtt = {
            Name: pollingplace["Name"],  
            Address: pollingplace["StreetAddress"] + ", " + pollingplace["City"]
            
        };

        this.pollingGraphic = new Graphic({
            geometry: pt,
            symbol: markerSymbol,
            attributes: pollingAtt,
            popupTemplate: new PopupTemplate({
                title: "{Name}",  // The title of the popup will be the name of the pipeline
                content: "{Address}"    // Displays a table of all the attributes in the popup
            })
        });

        this.locationGraphics.add(this.pollingGraphic);
    }

    //add a graphic for satellite voting locations
    addSatellitesGraphic(satellites: Array<Object>) {
        for (let satellite of satellites) {

            let satelliteLocation: Object = satellite["Location"];

            var pt: Point = new Point({
                x: satelliteLocation["X"],
                y: satelliteLocation["Y"],
                spatialReference: 2965
            });

            let markerSymbol = new PictureMarkerSymbol();
             markerSymbol.url = "./images/accessibility_blue.png";
             markerSymbol.width = 48;
             markerSymbol.height = 48;

            let satelliteAtt = {
                Name: satellite["Name"],  
                Address: satellite["StreetAddress"] + ", " + satellite["City"]
                 
            };

            let satelliteGraphic = new Graphic({
                geometry: pt,
                symbol: markerSymbol,
                attributes: satelliteAtt,
                popupTemplate: new PopupTemplate({
                    title: "{Name}",  // The title of the popup will be the name of the pipeline
                    content: "{Address}"    // Displays a table of all the attributes in the popup
                })
            });

            //this.mapViewRef.graphics.add(satelliteGraphic);
            this.locationGraphics.add(satelliteGraphic);
            // this.pollinglayer.add(satelliteGraphic);
        }
    }

    zoomMaptoLocation(location:Object) {
        var pt: Point = new Point({
            x: location["X"],
            y: location["Y"],
            spatialReference: 2965
        });
        this.mapViewRef.scale = 8000;
        this.mapViewRef.center = pt;
    }

    //function to run on slider change for toggleing aerial transparency 
    sliderChange(slidervalue:number) {
        // let opacityValue:number = parseInt(this.mapSlider.value);
        let opacityValue:number = slidervalue;
        this.aeriallayer.opacity = opacityValue / 100;
        this.initTransparencyValue = slidervalue;
    }

    //function for immediatly toggleing basemap/aerial when clicking on the 
    //map/imagery buttons rather than the slider
    basemapToggle(slidervalue:number) {
        this.initTransparencyValue = slidervalue;
    }
    
    //function for toggling the precincts layer on/off
    precinctsToggle(togglevalue:boolean) {

        ////Note - for whatever reason, toggling the visibility using layer.visible does not work here 
        ////when defaulting the layer visibility to false on initial load. So when to toggling transparency
        //  this.precinctslayer.visible = this.precinctsDisplay;

        togglevalue ? this.precinctslayer.opacity = 1 : this.precinctslayer.opacity = 0;
    }

    directionsAddrToggle(togglevalue:boolean) {
        this.newStartAddress = null;
        togglevalue ? this.useDiffAddress = true : this.useDiffAddress = false;
        this.useDiffAddress  &&  this.newStartAddress ? this.directionsStartAddress = this.newStartAddress : this.directionsStartAddress = null;
        !this.useDiffAddress  ? this.directionsStartAddress = this.selectedAddress : null;
        this.showDirections = false;
        this.routelayer.removeAll();
    }

    stopLocationChange(togglevalue:boolean) {
        this.showDirections = false;
    }

    //function to get driving directions
    getDirections () {
        let directionsStop: string = this.selectedStop;
        let isSatelliteStop:boolean;
        directionsStop.indexOf('satellite') >= 0 ? isSatelliteStop = true: isSatelliteStop = false;
        //clear out graphics
        this.routelayer.removeAll();
        this.routeInProgress = true;
        // Point the URL to a valid route service
        let routeTask = new RouteTask({
            url: this.appSettings["routingService"]["url"]
        });
        // Setup the route parameters
        let routeParams = new RouteParameters({
            stops: new FeatureSet(),
            outSpatialReference: { // autocasts as new SpatialReference()
                wkid: 2965
            }
        });
        // Define the symbology used to display the start location
        let startSymbol = new SimpleMarkerSymbol({
            style: "cross",
            size: 15,
            outline: { // autocasts as new SimpleLineSymbol()
                width: 4
            },
            color: new Color("#2E4172")
        });
        let startLocation = this.directionsStartAddress["addressLocation"];
        let startddress: Object = this.directionsStartAddress["addressSuggestion"];
        var startPt: Point = new Point({
            x: startLocation ["X"],
            y: startLocation ["Y"],
            spatialReference: 2965
        });
        let startAtt = {
            Name: startddress["FullAddress"] 
        };
        // Add a point at the location of the map click
        let start = new Graphic({
          geometry: startPt,
          attributes: startAtt,
          symbol: startSymbol,
          
        });
        this.startAddrText = startddress["FullAddress"];
        let stopLocation:Object;
        let stopPt: Point;
        let stopAtt:any;
        // Define the symbology used to display the stop location
        let stopSymbol = new SimpleMarkerSymbol({
            style: "cross",
            size: 15,
            outline: { // autocasts as new SimpleLineSymbol()
                width: 4
            }
        });
        let stopName:string;
        if (!isSatelliteStop) {
            stopLocation = this.pollingLocation;
            stopName = this.pollingPlaceFacility["Name"] + " " + this.pollingPlaceFacility["StreetAddress"] + ", " + this.pollingPlaceFacility["City"];
        } else {
            this.selectedSatellite = this.satelliteVotingPlaces[directionsStop.split("-")[1]];
            stopLocation = this.selectedSatellite["Location"];
            stopName = this.selectedSatellite["Name"] + " " + this.selectedSatellite["StreetAddress"] + ", " + this.selectedSatellite["City"]
        }
        this.stopAddrText = stopName;
        stopPt = new Point({
            x: stopLocation ["X"],
            y: stopLocation ["Y"],
            spatialReference: 2965
        });
        stopAtt = {
            Name: stopName
        };
        // Add a point at the location of the map click
        let stop = new Graphic({
          geometry: stopPt,
          attributes: stopAtt,
          symbol: stopSymbol
        });
        this.routelayer.add(start);
        this.routelayer.add(stop);
        routeParams.stops["features"].push(start);
        routeParams.stops["features"].push(stop);
        if (routeParams.stops["features"].length >= 2) {
            routeParams.impedanceAttribute = this.appSettings["routingService"]["impedance"];
            routeParams.returnDirections = true;
            routeTask.solve(routeParams).then(route => {
                //create symbol for route graphic
                let routeSymbol = new SimpleLineSymbol({
                    color: new Color("#FF0000"),
                    width: 5
                });
                //get the route result 
                this.routeResult = route.routeResults[0].route;
                //get the list of directions
                let routeDirections:DirectionsFeatureSet = route.routeResults[0].directions;
                this.routeDirectionList = routeDirections.features;
                this.routeResult.symbol = routeSymbol;
                this.routelayer.add(this.routeResult);
                this.showDirections = true;
                this.routeInProgress = false;
                this.routeExtent = this.routeResult.geometry.extent.expand(1.5);
                this.mapViewRef.extent = this.routeExtent;
            })
            .otherwise(errback => {
                console.log(errback);
            });
        }
    }

    printDirections() {
        this.printInProgress = true;
        let mapImage:Object;
        //   let container = document.getElementById("printArea");
        let container = document.getElementById("directionsList"); 
        var div = document.createElement('div');
        div.innerHTML = "<span>Directions from " + this.startAddrText + " to " + this.stopAddrText + ":</span>";
        div.innerHTML += container.innerHTML;
        this.getMap().subscribe(
            data => { 
                this.printInProgress = false;
                mapImage = data;
                this.exportedMapImgURL = '<img src="' + mapImage["url"] + '" width="800" height="500">'; 
                // this.showPrint = true;
                var width = parseFloat("800");
                var height = parseFloat("500");
                var printWindow = window.open('',"_parent ", 'PrintMap');
                printWindow.document.writeln(this.exportedMapImgURL + "<br/><br/>" + div.innerHTML);
                printWindow.document.close();
                setTimeout(() => {
                    printWindow.print();
                }, 1000);
                // printWindow.close();
            }, err => { 
                alert("We were unable to print directions. Please try again later.");
                this.error = false;
                this.printInProgress = false;
            }
        );
    }

    hidePrintModal() {
        this.showPrint = false;
    }

    showPrintDialog() {
        var width = parseFloat("800")
        let container = document.getElementById("directionsList"); 
        var height = parseFloat("500")
        var printWindow = window.open('', 'PrintMap',
        'width=' + width + ',height=' + height);
        
        printWindow.document.writeln(container.innerHTML);
        printWindow.document.close();
        printWindow.print();
        printWindow.close();
    }
    
    getMap():any {
        this.mapViewRef.extent = this.routeExtent;
        var printTask = new PrintTask(this.appSettings["printing"]["printingTask"]);
        var template = new PrintTemplate(
            new Object(this.appSettings["printing"]["printingTemplate"])
        );
        var params:PrintParameters = new PrintParameters();
        params.view = this.mapViewRef;
        params.template = template;
        return Observable.fromPromise(printTask.execute(params).then(result => {
            return result;
        }));
    }


    // Adds the solved route to the map as a graphic
    showRoute(data) {
        // Define the symbology used to display the route
        let routeSymbol = new SimpleLineSymbol({
            color: new Color("#FF0000"),
            width: 5
        });
        let routeResult = data.routeResults[0].route;
        routeResult.symbol = routeSymbol;
        this.zoomMaptoLocation(this.homeLocation);
      }

    closeMapToolsPanel() {
        this.panelHide = true;
    }

    showMapToolsPanel() {
        this.panelHide = false;
    }
          //show/hide the share via email panel
    toggleEmailPanel (display:boolean) {
        this.showEmailPanel = display;
        let forAddress:string;
        let ppPrecinctLabel:string;
        let ppNameLabel:string;
        let ppAddressLabel:string;
        let ppCityLabel:string;
        let accessibilityText:string 
        this.emailBody = "";

        let container = document.getElementById("directionsList"); 
        var div = document.createElement('div');
        div.innerHTML = "<span>Directions from " + this.startAddrText + " to " + this.stopAddrText + ":</span>";
        div.innerHTML += container.innerHTML;
        this.emailSubject = "Polling Place Driving Directions";
        this.getMap().subscribe(
            data => { 
                let emailMapImgURL = "";
                if(data["url"]){
                    emailMapImgURL = '<img src="' + data["url"] + '" width="800" height="500">';
                }
                this.emailBody = emailMapImgURL + "<br/><br/>" + div.innerHTML;
            }, err => {
                this.emailBody = div.innerHTML;
            }
        );
    }
} 


// WEBPACK FOOTER //
// ./app/information/map/mapview.component.ts